import { css } from '@emotion/core';
import { token } from '@atlaskit/tokens';

import { borderColor, borderRadius, colors, VIEWING_WIDTH } from '@/styles';

// NOTE: Consider creating one `Card` component for better encapsulation.
export const MINI_CARD_HEIGHT = 133;
export const LARGE_CARD_HEIGHT = 271;
export const LARGE_CARD_WIDTH = VIEWING_WIDTH;
export const sharedCardStyles = css`
  background-color: ${token('elevation.surface', colors.N0)};
  border: 1px solid ${borderColor};
  ${borderRadius};
`;
